/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_blog_related_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Related Posts`)
};

const es_blog_related_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículos relacionados`)
};

const de_blog_related_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwandte Beiträge`)
};

const nl_blog_related_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerelateerde berichten`)
};

const fr_blog_related_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articles connexes`)
};

const it_blog_related_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articoli correlati`)
};

const pt_br2_blog_related_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artigos relacionados`)
};

const pt_blog_related_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artigos relacionados`)
};

const ja_blog_related_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`関連記事`)
};

const zh_blog_related_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相关文章`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const blog_related_posts = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.blog_related_posts(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("blog_related_posts", locale)
	if (locale === "en") return en_blog_related_posts(inputs)
	if (locale === "es") return es_blog_related_posts(inputs)
	if (locale === "de") return de_blog_related_posts(inputs)
	if (locale === "nl") return nl_blog_related_posts(inputs)
	if (locale === "fr") return fr_blog_related_posts(inputs)
	if (locale === "it") return it_blog_related_posts(inputs)
	if (locale === "pt-BR") return pt_br2_blog_related_posts(inputs)
	if (locale === "pt") return pt_blog_related_posts(inputs)
	if (locale === "ja") return ja_blog_related_posts(inputs)
	return zh_blog_related_posts(inputs)
};